import { FormControl, FormErrorMessage, Text } from '@chakra-ui/react';
import React from 'react';
import { FieldError } from 'react-hook-form';
import Select, { Props } from 'react-select';

interface SelectProps extends Props {
  label?: string;
  width?: string;
  error?: FieldError;
  defaultStyle?: boolean;
  noOptionsText?: string;
  required?: boolean;
  maxW?: string;
  labelFontSize?: string;
}

export const ReactSelect: React.FC<SelectProps> = ({
  options,
  error = null,
  label,
  placeholder,
  noOptionsText,
  defaultStyle = false,
  required = false,
  maxW = '',
  labelFontSize = '14px',
  ...props
}) => {
  return (
    <FormControl
      display="flex"
      bg="cian"
      flexDir="column"
      isInvalid={!!error}
      maxW={maxW}
    >
      {label && (
        <Text fontSize={labelFontSize} mb={2} fontWeight="medium">
          {label}{' '}
          {required && (
            <Text as="span" color="red.500">
              *
            </Text>
          )}
        </Text>
      )}

      <Select
        options={options}
        placeholder={placeholder}
        noOptionsMessage={({ inputValue }) =>
          inputValue ? 'Nenhum resultado encontrado' : noOptionsText
        }
        styles={
          !defaultStyle
            ? {
                multiValue: provided => ({
                  ...provided,
                  width: '100%',
                }),
                multiValueLabel: provided => ({
                  ...provided,
                  marginRight: 'auto', // push the delete icon to the far right
                }),
                valueContainer: provided => ({
                  ...provided,
                  minHeight: 30,
                }),
                control: (provided, state) => ({
                  ...provided,
                  border: error ? 'solid 1px #e53e3e' : 'none',
                  width: '100%',
                  boxShadow: error ? '0 0 0 1px #e53e3e' : 'none',
                  '&:hover': {
                    border: 'none',
                  },
                }),
              }
            : {
                control: (provided, state) => ({
                  ...provided,
                  minWidth: '250px',
                }),
              }
        }
        {...props}
      />
      {!!error && <FormErrorMessage>{error.message}</FormErrorMessage>}
    </FormControl>
  );
};
